import { getAuth } from "firebase/auth";

export async function fetchProfile() {
    const auth = getAuth();
    const user = auth.currentUser;

    if(!user) {
        throw new Error("Not authenticated");
    }

    const token = await user.getIdToken();
    const res = await fetch("/api/profile", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    if(!res.ok) {
        throw new Error("Failed to fetch profile");
    }

    return res.json();
}